import { UsersIcon } from 'lucide-react'
import { SectionHeader } from '../SectionHeader'
import type { EngagementModelData } from '@/data/solutions/types'

type EngagementModelProps = EngagementModelData

export const EngagementModel = ({
  heading,
  advantages
}: EngagementModelProps) => {
  return (
    <div className="space-y-10">
      <SectionHeader
        label="Engagement Model"
        icon={<UsersIcon className="h-4 w-4" />}
        heading={heading}
        color="inc-primary-10"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {advantages.map(item => (
          <div
            key={item.title}
            className="flex flex-col justify-between gap-4 border-l-4 pl-4"
            style={{ borderColor: item.color }}
          >
            <div className="flex items-center gap-3">
              <div className="text-2xl font-bold" style={{ color: item.color }}>
                <span>{item.title}</span>
              </div>
            </div>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
